import React, { useContext } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { styled } from 'linaria/react';
import { Typography } from 'fronton-react';
import { RouteContext } from 'entries/common/widgets/context';
import { gaClickOnGoods } from 'ga-events/ga-click-goods';
import { calculationState, useCalculationState } from 'pages/calculation/store/calculation';
import { dimensionsAtom } from 'pages/dimensions/store/dimensions';
import { getRoomTypeTitle } from 'pages/common/helpers/get-room-type-title';
import { calculatedRoomsParams } from 'pages/common/store/rooms';
import { getAreaUser } from 'pages/common/helpers/get-area-user.helper';
import { useTranslation } from 'react-i18next';
import { EditParamsButton } from './EditParamsButton';
import { AdditionalInfo } from './AdditionalInfo';
import { RoomParamsContainer, ParamsListContainer } from './room-params.styles';

export const RoomParamsComponent: React.FC = () => {
  const { t } = useTranslation();
  const dimensions = useRecoilValue(dimensionsAtom);
  const { surface, inputParameters } = dimensions;

  const calculatedRoomParams = useRecoilValue(calculatedRoomsParams);
  const setCalculatorState = useSetRecoilState(calculationState);
  const { setContext: setRoute } = useContext(RouteContext);

  const { calculationFormState } = useCalculationState();
  const { addToCartIsSuccessful } = calculationFormState;

  const areaUser = getAreaUser({
    width: Number(inputParameters.width),
    length: Number(inputParameters.length),
    areaUser: Number(inputParameters.areaUser),
  });

  const roomTypeTitle = getRoomTypeTitle({ room: calculatedRoomParams, translate: t });

  const handleClick = () => {
    gaClickOnGoods({
      title: addToCartIsSuccessful ? 'Добавлено в корзину' : 'Результат по размерам',
      name: 'Изменить',
    });
    setCalculatorState(prevState => ({
      ...prevState,
      count: '',
    }));
    setRoute('dimensions');
  };

  return (
    <RoomParamsContainer onClick={handleClick}>
      <ParamsListContainer data-testid="calculation-params-list">
        <ParamsListColumn>
          <ParamsListRow>
            <Typography
              color="text-primary"
              size="body_accent"
              variant="l"
              data-testid="configuration-title">
              {roomTypeTitle}&nbsp;
            </Typography>
            <Typography
              color="text-primary"
              size="body_accent"
              variant="l"
              data-testid="configuration-value">
              {`${areaUser} м²`}
            </Typography>
          </ParamsListRow>
          <AdditionalInfo surface={surface} inputParameters={inputParameters} />
        </ParamsListColumn>
        <ParamsListColumnRight>
          <EditParamsButton />
        </ParamsListColumnRight>
      </ParamsListContainer>
    </RoomParamsContainer>
  );
};

const ParamsListColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-75);

  @media (--only-mobile) {
    gap: var(--space-50);
  }
`;
const ParamsListRow = styled.div`
  display: flex;
  flex-direction: row;
`;

const ParamsListColumnRight = styled(ParamsListColumn)`
  margin-right: 0;
  margin-left: auto;
`;
